/* global google */
import { connect } from 'react-redux';
import { fieldPropTypes } from 'redux-form';
import PlacesAutocomplete from 'react-places-autocomplete';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { baseInput, getBorderColor } from './Styles';
import Input from '../../components/Form/Input';
import Style from '../../styles/common';

const StyledInput = styled('input')`
  ${baseInput};
  border-color: ${props => getBorderColor(props)};
`;

const DropdownContainer = styled('div')`
  border: 1px solid ${Style.color.INPUT.BORDER};
  border-radius: ${Style.BORDER_RADIUS};
  box-shadow: ${Style.INPUT_MODAL_BOX_SHADOW};
  margin-top: ${Style.MEASUREMENT.INPUT.MODAL_OFFSET};
  padding: ${Style.MEASUREMENT.INPUT.MODAL_PADDING};
`;

const SuggestedItem = styled('div')`
  background-color: ${props => props.active && Style.color.INPUT.HOVER};
  border-radius: ${Style.BORDER_RADIUS};
  font-family: ${Style.FONT_FAMILY.DEFAULT};
  font-weight: ${Style.FONT_WEIGHT.MEDIUM};
  line-height: 1.75;
  padding: ${Style.MEASUREMENT.INPUT.MODAL_ITEM_PADDING};
`;

class LocationInput extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    gmapsLoaded: PropTypes.bool.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    placeholder: '',
    type: 'text',
  };

  render() {
    if (!this.props.gmapsLoaded) {
      return null;
    }

    const { input } = this.props;
    const queenElizabethParkLatLng = [32.292563,-64.786908];

    const searchOptions = {
      location: new google.maps.LatLng(...queenElizabethParkLatLng),
      radius: 80000,
    };

    return (
      <Input {...this.props}>
        <PlacesAutocomplete
          onChange={input.onChange}
          searchOptions={searchOptions}
          value={input.value}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div>
              <StyledInput
                {...this.props.input}
                {...getInputProps({
                  placeholder: this.props.placeholder,
                })}
              />
              {this.getDropdownContainer(suggestions, getSuggestionItemProps)}
            </div>
          )}
        </PlacesAutocomplete>
      </Input>
    );
  }

  getDropdownContainer(suggestions, getSuggestionItemProps) {
    if (!suggestions || suggestions.length === 0) {
      return null;
    }

    return (
      <DropdownContainer>
        {suggestions.map(suggestion => {
          return (
            <SuggestedItem
              {...getSuggestionItemProps(suggestion)}
              active={suggestion.active}
            >
              <span>{suggestion.description}</span>
            </SuggestedItem>
          )
        })}
      </DropdownContainer>
    );
  }
}

export default connect(
  state => ({
    gmapsLoaded: state.google.gmapsLoaded,
  }),
)(LocationInput);



// WEBPACK FOOTER //
// ./src/components/Form/LocationInput.js